import classNames from 'classnames';
import React from 'react';
import Identicon from 'react-identicons';

import UserIcon from '@sbu/assets.svg/src/user.svg';

import { ThemeContext } from 'shared/components/utils/Theme';

import css from './Avatar.module.scss';
import { AvatarSize, useAvatarImage } from './useAvatarImage';

interface AvatarProps {
  className?: string;
  email?: string | null;
  size?: AvatarSize;
  style?: any;
}

export function Avatar({
  className,
  email,
  size = 'medium',
  style,
}: AvatarProps) {
  const { imageType, imageUrl, dim } = useAvatarImage(email ?? '', size);

  if (imageType === 'gravatar' && imageUrl) {
    return <img className={className} src={imageUrl} style={style} />;
  }

  if (imageType === 'identicon') {
    return (
      <ThemeContext.Consumer>
        {({ palettes }) => (
          <Identicon
            className={classNames(className, css.identicon)}
            palette={palettes.identicon}
            size={dim}
            string={email}
          />
        )}
      </ThemeContext.Consumer>
    );
  }

  if (imageType === 'svg') {
    return (
      <UserIcon
        className={className}
        height={`${dim}px`}
        style={style}
        width={`${dim}px`}
      />
    );
  }

  return null;
}
